// =============================================================================
// Brand Constants — app.smart IDV (Identidade Visual)
// =============================================================================
// Fonte única de verdade para cores, gradientes e configurações de marca.
// Todos os componentes devem importar daqui em vez de usar hardcode.
// Referencia: /app-smart.html (Brand System Final)
// =============================================================================

// --- Cores principais da marca ---
export const BRAND_PRIMARY = '#9B2C2C'; // Red 700 — cor principal
export const BRAND_SECONDARY = '#BE185D'; // Pink 700 — cor secundaria
export const BRAND_ACCENT = '#EC4899'; // Pink 500 — acento / hover
export const BRAND_DARK = '#5D1A1A'; // Bordo profundo
export const BRAND_LIGHT = '#F472B6'; // Pink 400 — uso em dark mode

// --- Gradiente principal ---
export const BRAND_GRADIENT =
  'linear-gradient(135deg, #9B2C2C 0%, #BE185D 100%)';
export const BRAND_GRADIENT_CSS = {
  from: '#9B2C2C',
  to: '#BE185D',
  angle: 135,
};

// --- Paleta woot (Tailwind) ---
export const WOOT_PALETTE = {
  25: '#FEF2F2',
  50: '#FEE2E2',
  75: '#FECDD3',
  100: '#FECACA',
  200: '#FCA5A5',
  300: '#F87171',
  400: '#EF4444',
  500: '#DC2626',
  600: '#B91C1C',
  700: '#9B2C2C',
  800: '#7F1D1D',
  900: '#5D1A1A',
};

// --- Cores semanticas para charts/reports ---
export const CHART_COLORS = {
  primary: '#9B2C2C',
  secondary: '#BE185D',
  accent: '#EC4899',
  positive: '#059669',
  negative: '#DC2626',
  warning: '#D97706',
  info: '#0891B2',
  neutral: '#64748B',
  violet: '#7C3AED',
  amber: '#F59E0B',
};

// Paleta sequencial para donut/pie charts (ate 10 itens)
export const CHART_PALETTE = [
  '#9B2C2C', // brand primary
  '#BE185D', // brand secondary
  '#EC4899', // pink 500
  '#F59E0B', // amber 500
  '#059669', // emerald 600
  '#0891B2', // cyan 600
  '#7C3AED', // violet 600
  '#DC2626', // red 600
  '#2563EB', // blue 600
  '#64748B', // slate 500
];

// --- Paleta para bar charts (main + comparison) ---
export const BAR_COLORS = {
  main: '#9B2C2C',
  comparison: '#FECACA',
  hover: '#BE185D',
};

// --- Tooltip padrao para Chart.js ---
export const CHART_TOOLTIP_STYLE = {
  enabled: true,
  backgroundColor: 'rgba(15, 23, 42, 0.95)',
  titleColor: 'rgba(248, 250, 252, 1)',
  bodyColor: 'rgba(226, 232, 240, 1)',
  borderColor: 'rgba(51, 65, 85, 1)',
  borderWidth: 1,
  cornerRadius: 8,
  padding: 12,
  boxPadding: 4,
  caretSize: 6,
  caretPadding: 8,
  titleFont: { size: 13, weight: '600' },
  bodyFont: { size: 12 },
};

// --- Formularios ---
export const FORM_PRIMARY_COLOR = '#9B2C2C';

// --- Click ID labels (UTM attribution) ---
export const CLICK_ID_LABELS = {
  gclid: 'Google Ads',
  gbraid: 'Google Ads (App)',
  wbraid: 'Google Ads (Web)',
  dclid: 'Google DV360',
  fbclid: 'Facebook',
  fbc: 'Facebook Conv.',
  fbp: 'Facebook Pixel',
  ctwa_clid: 'WhatsApp CTWA',
  leadgen_id: 'Meta Lead Ads',
  ttclid: 'TikTok',
  li_fat_id: 'LinkedIn',
  msclkid: 'Microsoft Ads',
  twclid: 'Twitter/X',
  epik: 'Pinterest',
  ScCid: 'Snapchat',
  sck: 'Snapchat (alt)',
  rdt_cid: 'Reddit',
};
